import dayjs from 'dayjs';

const dateFilterValueMatcher = (
  from: string,
  to: string,
  emptyFlag: string,
  time?: string,
) => {
  if (emptyFlag === 'true') return !time;
  if (!time) return false;

  const timeDayjs = dayjs(time);

  return (
    (!from || dayjs(from).startOf('day').isBefore(timeDayjs)) &&
    (!to || dayjs(to).endOf('day').isAfter(timeDayjs))
  );
};

export default dateFilterValueMatcher;
